const _ = require('lodash');
const appSettings = require('swa-app-config/settings');
const ariaLiveActions = require('swa-accessibility/aria-live-actions');
const browser = require('swa-browser/browser');
const browserWindow = window;
const classNames = require('classnames');
const Container = require('swa-components-core/container');
const contentActions = require('swa-content/content-actions');
const CorporateLandingHomePageDashboard = require('./corporate-landing-home-page-dashboard');
const CorporateLandingHomePageLibrary = require('swa-landing-page/lib/landing-library');
const CorporateLandingHomePageTabNavigation = require('swa-landing-page/landing-tab-navigation');
const CorporateLandingHomePageTabNavigationColdPanels = require('./corporate-landing-home-page-tab-navigation-cold-panels');
const CorporateLandingHomePageTabNavigationHotPanels = require('./corporate-landing-home-page-tab-navigation-hot-panels');
const CorporateLoginHeaderData = require('./corporate-login-header-data');
const corporateLoginLibrary = require('swa-corporate-login/corporate-login-library.corporate');
const corporateStore = require('swa-corporate/corporate-store.corporate').instance;
const createReactClass = require('create-react-class');
const customerStore = require('swa-customer/customer-store').instance;
const DataStoreHOC = require('swa-landing-page/lib/data-store-hoc');
const DataStoreMixin = require('swa-flux/data-store-mixin');
const Focus = require('swa-browser/focus');
const geolocationStore = require('swa-geolocation/geolocation-store/geolocation-store').instance;
const i18n = require('swa-locale/i18n');
const LandingAirUpcomingTripsBanner = require('swa-landing-page/landing-air-upcoming-trips-banner');
const location = require('swa-location/location');
const MetadataMixin = require('swa-metadata/metadata-mixin');
const mboxActions = require('swa-mbox/mbox-actions');
const mboxStore = require('swa-mbox/mbox-store').instance;
const PageNotifications = require('swa-notifications/page-notifications');
const PlacementFactory = require('swa-content-core/placement-factory');
const React = require('react');
const searchActions = require('swa-search/search-actions');
const Section = require('swa-components-core/section');
const SkipToContentLink = require('swa-accessibility/skip-to-content-link');
const StatePersistenceHOC = require('swa-persistence/state-persistence-hoc');
const upcomingTripsStore = require('swa-search/search-store').instance('LandingPageUpcomingTrips');
const pageId = location.getPageIdentifier();
const { landingHomePageIndexAnalytics } = require('swa-analytics/landing-home-page');
const { enableCarTrawler, seatSelectionEligibleDate } = appSettings.getAppProps();
const { loadCarSection } = require('@swa-ui/car');

const UpcomingTripsBannerWithLoggedInStatus = DataStoreHOC(customerStore, LandingAirUpcomingTripsBanner, (store) => ({
    loggedIn: store.isLoggedIn(),
    customerAccountNumber: store.state?.customerInformation?.accountNumber,
    seatSelectionEligibleDate: seatSelectionEligibleDate 
}));
const placements = [
    'landingHomePageIndexContentModule1',
    'landingHomePageIndexContentModule2',
    'landingHomePageIndexContentModule3',
    'landingHomePageIndexContentModule4',
    'landingHomePageIndexContentModule5',
    'landingHomePageIndexContentModule6',
    'landingHomePageIndexContentModule7',
    'landingHomePageIndexContentModule8'
];
let upcomingTripsBannerFired = false;


const CorporateLandingHomePageIndex = createReactClass({
    displayName: 'CorporateLandingHomePageIndex',
    mixins: [DataStoreMixin, MetadataMixin],
    navigator: appSettings.getAppProps().Navigator,

    stores: [
        { dataStore: customerStore, callback: 'customerStoreUpdated' },
        { dataStore: mboxStore, callback: 'handleMboxStoreChange' },
        { dataStore: upcomingTripsStore, callback: 'upcomingTripsStoreUpdated' }
    ],

    tabNavigationData: {},

    getInitialState() {
        const { enableCashPlusPoints = false } = appSettings.getAppProps();
        const showCashPlusPointsOption = mboxStore.getTestValue('CashPlusPointsOptionDisplay');

        return {
            activeChangeCancelTab: 'change',
            corporateLandingHomePageAirBookingSearchFormSearching: false,
            corporateLandingHomePageAirReservationSearchFormSearching: false,
            corporateLandingHomePageCarBookingSearchFormSearching: false,
            corporateLandingHomePageCheckInAirReservationFormSearching: false,
            corporatelandingHomePageFlightStatusSearchFormSearching: false,
            fitState: this.getFitState().fitState,
            formsDisabled: this.getFitState().formDisabled,
            isAnonymous: true,
            loggedIn: this.isUserLoggedIn(),
            nearestStation: this.getNearestAirportCode(),
            selectedTab: this.getDefaultTab(this.isUserLoggedIn()),
            shouldDisplayCashPlusPointsOption: showCashPlusPointsOption === 'show' && enableCashPlusPoints
        };
    },

    componentWillMount() {
        this.getAppSettings();
    },

    componentDidMount() {
        const selectedTab = this.getSelectedTab();

        this.preventBrowserCache();
        Focus.focusToDocumentElement();

        const defaultTab = this.getDefaultTab(this.isLoggedIn());
        const newSelectedTab = this.getSelectedTabIndexByKey(selectedTab) === 0 ? defaultTab : selectedTab;

        this.setState({
            selectedTab: newSelectedTab
        });

        corporateLoginLibrary.deleteStoresFromStorage();

        if (enableCarTrawler && selectedTab === 'car') {
            loadCarSection(this.getLoadCarSectionOptions());
        }

        landingHomePageIndexAnalytics();
    },

    componentDidUpdate() {
        if (enableCarTrawler && this.state.selectedTab === 'car') {
            loadCarSection(this.getLoadCarSectionOptions());
        }
    },

    componentWillUpdate() {
        const logoutState = !this.isLoggedIn();
        const userLogoutState = !this.isUserLoggedIn();

        if (logoutState !== userLogoutState) {
            this.customerStoreUpdated();

            SkipToContentLink.focus();
            this.announceTitle();
        }
    },

    render() {
        return (
            <div>
                <UpcomingTripsBannerWithLoggedInStatus />
                <Container {...this.getProps()}>
                    <Section className="page-index--section" headingContent={this.getHeadingContent()}>
                        <PlacementFactory {...this.getPlacementBackgroundProps()}>
                            {this.renderDashboard()}
                            <Container className={this.getContentClass()}>
                                {this.renderContentByState()}
                                {this.renderTabNavigation()}
                            </Container>
                            {this.renderPlacements(placements)}
                        </PlacementFactory>
                    </Section>
                </Container>
            </div>
        );
    },

    renderDashboard() {
        return this.isDashboardEnabled() ? (
            <CorporateLandingHomePageDashboard {...this.getCorporateLandingHomePageDashboardProps()} />
        ) : null;
    },

    renderContentByState() {
        const content = [
            // eslint-disable-next-line react/jsx-key
            <PageNotifications {...this.getPageNotificationsProps()} />,
            // eslint-disable-next-line react/jsx-key
            <div {...this.getHeroProps()}>
                <PlacementFactory {...this.getHeroPlacementProps()} />
            </div>
        ];

        return !this.isLoggedIn() ? content : content.reverse();
    },

    renderTabNavigation() {
        let dataToRender = null;

        if (this.areFormsEnabled()) {
            dataToRender = (
                <div className={this.getWrapperClass('tab-navigation')}>
                    <CorporateLandingHomePageTabNavigation {...this.getTabNavigationProps()} />
                </div>
            );
        }

        return dataToRender;
    },

    renderPlacements() {
        return _.map(
            placements,
            function (placement, index) {
                const { state } = this;

                if (state.fitState) {
                    placement = `${placement}fit`;
                }

                return <PlacementFactory {...this.getPlacementProps(placement, index)} />;
            },
            this
        );
    },

    getProps() {
        return {
            className: 'corporate-landing-home-page-index',
            type: 'fullScreen'
        };
    },

    getLoadCarSectionOptions() {
        return {
            autoNavigateOnSubmit: false, 
            onSubmit: this.handleCarSectionSubmit, 
            shouldSetSessionData: true, 
            suppliersAllowed: corporateStore.getApprovedCars(),
            waitForElement: true 
        };
    },

    getHeadingContent() {
        return <span className="swa-g-screen-reader-only">{i18n('ARIA__SOUTHWEST')}</span>;
    },

    getPlacementBackgroundProps() {
        return {
            backgroundAnimation: this.getBackgroundAnimationSettings(),
            className: 'page-index--background',
            classNameWrapper: 'page-index--background-wrapper',
            placementId: this.getPlacements(['landingHomePageIndexBackground'])[0],
            shouldRenderWithoutContent: true,
            showChildren: true
        };
    },

    getPageNotificationsProps() {
        const className = 'page-index--page-notifications-item';

        return {
            animation: this.getAnimationSettings('pageNotifications'),
            classNamePageError: className,
            classNamePageMessage: className,
            classNameSystemMessage: className,
            hidePageErrors: true,
            key: 'page-notification'
        };
    },

    getHeroProps() {
        return {
            className: this.getWrapperClass('hero'),
            key: 'hero-placement'
        };
    },

    getHeroPlacementProps() {
        return {
            animation: this.getAnimationSettings('hero'),
            placementId: this.getPlacements(['landingHomePageIndexHero'])[0]
        };
    },

    getCorporateLandingHomePageDashboardProps() {
        return {
            animation: this.getAnimationSettings('dashboard'),
            companyEnrolledRapidRewards: this.isCompanyEnrolledRapidRewards(),
            dashboardName: this.getDashboardName(),
            rapidRewardsMaintenance: this.isMetaDataToggleOn('rapidRewardsMaintenance'),
            rewardsSummary: corporateStore.getRewardsSummary(),
            unusedFundsInd: corporateStore.isUnusedFundsIndEnabled()
        };
    },

    getDashboardName() {
        return this.isCompanyEnrolledRapidRewards()
            ? customerStore.getCtmInformation().firstName
            : corporateStore.getCompanyName();
    },

    getWrapperClass(wrapperName) {
        return `page-index--${wrapperName}_${this.getWidthByState()}`;
    },

    getContentClass() {
        return classNames('page-index--page-content', this.getWrapperClass('page-content'));
    },

    getAirReservationChangeFormProps() {
        return {
            formData: this.state.corporateLandingHomePageChangeSearchFormData,
            formType: 'change',
            hideRequiredIndicator: false,
            key: 'change-form',
            onFormUpdated: this.handleChangeFormUpdated,
            onValidFormSubmitted: this.handleAirReservationForm,
            searching: this.state.corporateLandingHomePageAirReservationSearchFormSearching,
            width: this.getWidthByState()
        };
    },

    getAirReservationCancelFormProps() {
        return {
            formData: this.state.corporateLandingHomePageCancelSearchFormData,
            formType: 'cancel',
            hideRequiredIndicator: false,
            key: 'cancel-form',
            onFormUpdated: this.handleCancelFormUpdated,
            onValidFormSubmitted: this.handleAirReservationForm,
            searching: this.state.corporateLandingHomePageAirReservationSearchFormSearching,
            width: this.getWidthByState()
        };
    },

    getChangeFormProps() {
        return {
            cancelFormProps: this.getAirReservationCancelFormProps(),
            changeFormProps: this.getAirReservationChangeFormProps()
        };
    },

    getChangeCancelFormProps() {
        const { state } = this;
        const searchFormData = state.corporateLandingHomePageChangeCancelSearchFormData;

        return {
            formData: searchFormData ? searchFormData : undefined,
            formType: 'change-cancel',
            hideRequiredIndicator: true,
            key: 'change-cancel-form',
            onFormUpdated: this.handleChangeCancelFormUpdated,
            onValidFormSubmitted: this.handleAirReservationForm,
            searching: state.corporateLandingHomePageAirReservationSearchFormSearching,
            width: this.getWidthByState()
        };
    },

    getLoginFormProps() {
        return {
            className: this.getContainerClass(false),
            travelerHeaderData: CorporateLoginHeaderData.traveler,
            travelManagerHeaderData: CorporateLoginHeaderData.travelManager
        };
    },

    getFlightFormProps() {
        const { state } = this;
        const searchFormData = state.corporateLandingHomePageAirSearchSearchFormData;

        return {
            className: 'page-index--tab-navigation-form-container',
            fareSelectorDisabled: this.isFareSelectorDisabled(),
            formData: searchFormData ? searchFormData : undefined,
            key: 'flight-form',
            nearestStation: state.nearestStation,
            onFormUpdated: this.handleAirSearchFormUpdated,
            onValidFormSubmitted: this.handleCorporateLandingAirSearchForm,
            searching: state.corporateLandingHomePageAirBookingSearchFormSearching,
            shouldDisplayCashPlusPointsOption: state.shouldDisplayCashPlusPointsOption
        };
    },

    getCheckInFormProps() {
        const { state } = this;
        const searchFormData = state.corporateLandingHomePageCheckInAirReservationSearchFormData;

        return {
            className: this.getContainerClass(true),
            formData: searchFormData ? searchFormData : undefined,
            formType: 'check-in',
            hideRequiredIndicator: this.isLoggedIn(),
            interstitial: false,
            key: 'check-in-form',
            onFormUpdated: this.handleCheckInFormUpdated,
            onValidFormSubmitted: this.handleCorporateLandingPageCheckInAirReservationForm,
            searching: state.corporateLandingHomePageCheckInAirReservationFormSearching,
            showTitle: !this.isLoggedIn(),
            width: this.getWidthByState()
        };
    },

    getFlightStatusFormProps() {
        const { state } = this;
        const searchFormData = state.corporateLandingHomePageFlightStatusSearchFormData;

        return {
            className: this.getContainerClass(false),
            formData: searchFormData ? searchFormData : undefined,
            hideRequiredIndicator: this.isLoggedIn(),
            interstitial: false,
            key: 'flight-status-form',
            onFormUpdated: this.handleFlighStatusFormUpdated,
            onValidFormSubmitted: this.handleFlightStatusForm,
            searching: state.corporatelandingHomePageFlightStatusSearchFormSearching,
            showTitle: !state.loggedIn,
            width: this.getWidthByState()
        };
    },

    getTabNavigationProps() {
        const selectedTabIndex = this.getSelectedTabIndexByKey(this.getSelectedTab());

        this.tabNavigationData = this.getTabPanelContentProps();

        return {
            animation: this.getAnimationSettings('tabNavigation'),
            className: this.getTabNavigationClass(),
            defaultSelectedTabIndex: selectedTabIndex,
            onTabSelection: this.handleTabNavigationSelection,
            selectedTabIndex: selectedTabIndex,
            tabNavigationData: this.tabNavigationData,
            width: this.getWidthByState()
        };
    },

    customerStoreUpdated() {
        const isLoggedIn = this.isLoggedIn();
        const isUserLoggedIn = this.isUserLoggedIn();
        let selectedTabKey;
        let updateState;

        if (isLoggedIn !== isUserLoggedIn) {
            selectedTabKey = this.getDefaultTab(isUserLoggedIn);

            updateState = _.assign(this.getCleanFormState(), {
                loggedIn: isUserLoggedIn,
                nearestStation: this.getNearestAirportCode(),
                selectedTab: selectedTabKey
            });

            this.setState(updateState);
        }

        if (!isUserLoggedIn) {
            upcomingTripsBannerFired = false;
        }

        landingHomePageIndexAnalytics();
    },

    getCleanFormState() {
        const cleanFormState = {
            corporateLandingHomePageAirSearchSearchFormData: null,
            corporateLandingHomePageCancelSearchFormData: null,
            corporateLandingHomePageCarBookingSearchFormData: null,
            corporateLandingHomePageChangeCancelSearchFormData: null,
            corporateLandingHomePageChangeSearchFormData: null,
            corporateLandingHomePageCheckInAirReservationSearchFormData: null,
            corporateLandingHomePageFlightStatusSearchFormData: null
        };

        return this.isLoggedIn() ? cleanFormState : {};
    },

    getNearestAirportCode() {
        const geolocationData = geolocationStore.getData();
        let nearestStation = _.get(geolocationData, 'nearestStation', '');

        if (nearestStation === 'INFLIGHT' || corporateLoginLibrary.isCtmUserRole()) {
            nearestStation = '';
        }

        return nearestStation;
    },

    isUserLoggedIn() {
        return corporateLoginLibrary.isCorporateUserLoggedIn();
    },

    getPlacementProps(placementId, index) {
        return {
            animation: this.getAnimationSettings('ads'),
            key: index,
            placementId: placementId
        };
    },

    getTabPanelContentProps() {
        const clonedTabNavigationPanel = {};
        const disabledPanelKeys = this.getDisabledPanelKeys();
        const panels = !this.isLoggedIn()
            ? CorporateLandingHomePageTabNavigationColdPanels
            : CorporateLandingHomePageTabNavigationHotPanels;

        _.forOwn(
            panels,
            function (object, key) {
                clonedTabNavigationPanel[key] = this.getComponentForPanel(object, key);
            },
            this
        );

        return _.omit(clonedTabNavigationPanel, disabledPanelKeys);
    },

    getDisabledPanelKeys() {
        const disabledPanelKeys = [];
        let panelKey = null;
        const travelPolicies = corporateStore.getTravelPolicies();

        _.forOwn(travelPolicies, (value, key) => {
            if (_.includes(key, 'Available') && !value) {
                panelKey = key.replace('OptionAvailable', '');

                disabledPanelKeys.push(panelKey);
            }
        });

        if (!this.isLoggedIn() && this.isCiamLoginEnabled()) {
            disabledPanelKeys.push('login');
        }

        return disabledPanelKeys;
    },

    getTabNavigationClass() {
        const classNameTab = {
            'page-index--tab-navigation': true
        };
        const width = this.getWidthByState();

        classNameTab[`page-index--tab-navigation_${width}`] = true;

        return classNames(classNameTab);
    },

    getContainerClass(isLandingAirReservationSearchForm) {
        return classNames({
            'page-index--tab-navigation-form-container': true,
            'page-index--tab-navigation-form-container_small': !this.isLoggedIn(),
            'landing-air-reservation-search-form_small': isLandingAirReservationSearchForm && !this.isLoggedIn()
        });
    },

    isLoggedIn() {
        return this.state.loggedIn;
    },

    isLoggedInAsTraveler() {
        return this.state.loggedIn && customerStore.getUserRole() === 'TRAVELER';
    },

    handleMboxStoreChange () {
        const { enableCashPlusPoints = false } = appSettings.getAppProps();
        const showCashPlusPointsOption = mboxStore.getTestValue('CashPlusPointsOptionDisplay');

        this.setState({
            shouldDisplayCashPlusPointsOption: showCashPlusPointsOption === 'show' && enableCashPlusPoints
        });
    },

    handleCarSectionSubmit() {
        const analyticsParam = CorporateLandingHomePageLibrary.createQueryObject(
            i18n('ANALYTICS_PARAMETERS__HOME_PAGE__CAR_BOOKING_SEARCH')
        );
        const queryParamsCar = CorporateLandingHomePageLibrary.createQueryParams(analyticsParam);

        this.navigator.navigateToCarBooking(queryParamsCar);
    },

    handleCarFormUpdated(formData) {
        this.handleFormUpdated('corporateLandingHomePageCarBookingSearchFormData', formData);
    },

    handleCheckInFormUpdated(formData) {
        this.handleFormUpdated('corporateLandingHomePageCheckInAirReservationSearchFormData', formData);
    },

    handleFlighStatusFormUpdated(formData) {
        this.handleFormUpdated('corporateLandingHomePageFlightStatusSearchFormData', formData);
    },

    handleChangeCancelFormUpdated(formData) {
        this.handleFormUpdated('corporateLandingHomePageChangeCancelSearchFormData', formData);
    },

    handleChangeFormUpdated(formData) {
        this.handleFormUpdated('corporateLandingHomePageChangeSearchFormData', formData);
    },

    handleCancelFormUpdated(formData) {
        this.handleFormUpdated('corporateLandingHomePageCancelSearchFormData', formData);
    },

    handleAirSearchFormUpdated(formData) {
        this.handleFormUpdated('corporateLandingHomePageAirSearchSearchFormData', formData);
    },

    handleFormUpdated(storage, formData) {
        let newFormData = {};

        newFormData[storage] = formData;

        if (storage === 'corporateLandingHomePageAirSearchSearchFormData') {
            newFormData = _.assign({}, newFormData, { nearestStation: '' });
        }

        this.setState(newFormData);
    },

    handleTabNavigationSelection(index) {
        const selectedTabKey = this.getSelectedTabKeyByIndex(index);

        this.setState({
            selectedTab: selectedTabKey
        });
    },

    handleAirReservationForm(formData) {
        this.setChangeCancelFormData(formData);
        this.setChangeCancelAsDefaultTab();

        const formTypeKey = this.getFormTypeKey(formData);
        const formType = formData[formTypeKey];
        const navigateTo =
            formType === 'CANCEL' ? this.navigator.navigateToAirCancelReservation : this.navigator.navigateToAirChange;
        const airReservationQueryParams = this.getAirReservationQueryParams(formData, formTypeKey);
        const queryParams = CorporateLandingHomePageLibrary.createQueryParams(airReservationQueryParams);

        this.setState(
            {
                corporateLandingHomePageAirReservationSearchFormSearching: true
            },
            navigateTo(queryParams)
        );
    },

    handleCorporateLandingPageCarBookingForm(formData) {
        const carBookingQueryParams = this.getCarBookingQueryParams(formData);
        const queryParamsCar = CorporateLandingHomePageLibrary.createQueryParams(carBookingQueryParams);

        this.setState(
            {
                corporateLandingHomePageCarBookingSearchFormSearching: true
            },
            this.navigator.navigateToCarBooking(queryParamsCar)
        );
    },

    handleCorporateLandingPageCheckInAirReservationForm(formData) {
        const queryParams = this.getCheckInQueryParams(formData);
        const queryParamsCheckIn = CorporateLandingHomePageLibrary.createQueryParams(queryParams);

        this.setState(
            {
                corporateLandingHomePageCheckInAirReservationFormSearching: true
            },
            this.navigator.navigateToAirCheckIn(queryParamsCheckIn)
        );
    },

    handleCorporateLandingAirSearchForm(formData) {
        const queryParams = this.getAirSearchQueryParams(formData);
        const airSearchQueryParams = CorporateLandingHomePageLibrary.createQueryParams(queryParams);

        searchActions.updateResetStatus('ResetStatusSearchStore', true);
        this.setState(
            {
                corporateLandingHomePageAirBookingSearchFormSearching: true
            },
            this.navigator.navigateToAirBooking(airSearchQueryParams)
        );
    },

    getAirSearchQueryParams(formData) {
        const searchQuery =  {
            adultPassengersCount: formData.LandingAirBookingSearchForm_adultPassengersCount,
            departureDate: formData.LandingAirBookingSearchForm_departureDate,
            departureTimeOfDay: 'ALL_DAY',
            destinationAirportCode: formData.LandingAirBookingSearchForm_destinationAirportCode,
            fareType: formData.LandingAirBookingSearchForm_fareType,
            originationAirportCode: formData.LandingAirBookingSearchForm_originationAirportCode,
            passengerType: formData.LandingAirBookingSearchForm_passengerType,
            promoCode: formData.LandingAirBookingSearchForm_promoCode,
            reset: true,
            returnDate: formData.LandingAirBookingSearchForm_returnDate,
            returnTimeOfDay: 'ALL_DAY',
            tripType: formData.LandingAirBookingSearchForm_tripType
        };

        ["from", "to"].forEach(field => {
            const searchFormField = `LandingAirBookingSearchForm_${field}`;

            if (formData[searchFormField]) {
                searchQuery[field] = formData[searchFormField];
            }
        });

        return _.assign(
            {},
            CorporateLandingHomePageLibrary.createQueryObject(i18n('ANALYTICS_PARAMETERS__HOME_PAGE__AIR_SEARCH')),
            searchQuery
        );
    },

    handleFlightStatusForm(formData) {
        const queryParams = this.getFlightStatusQueryParams(formData);
        const queryParamsFlightStatus = CorporateLandingHomePageLibrary.createQueryParams(queryParams);

        this.navigator.navigateToFlightStatus(queryParamsFlightStatus);
    },

    isFareSelectorDisabled() {
        return this.isRapidRewardsDisabled() || corporateLoginLibrary.isCtmWithoutCorporatePointsAccess();
    },

    isRapidRewardsDisabled() {
        return this.getMetadataValue('rapidRewardsMaintenance', false);
    },

    getFormTypeKey(formData) {
        return _.findKey(formData, this.findFormType);
    },

    findFormType(data) {
        return data === 'CHANGE' || data === 'CANCEL';
    },

    getCheckInQueryParams(formData) {
        const queryParams = {
            confirmationNumber: formData['LandingAirReservationSearchForm_confirmationNumber_check-in'],
            passengerFirstName: formData['LandingAirReservationSearchForm_passengerFirstName_check-in'],
            passengerLastName: formData['LandingAirReservationSearchForm_passengerLastName_check-in']
        };

        return _.assign(
            queryParams,
            CorporateLandingHomePageLibrary.createQueryObject(
                i18n('ANALYTICS_PARAMETERS__HOME_PAGE__AIR_BOOKING_CHECKIN')
            )
        );
    },

    getFlightStatusQueryParams(formData) {
        return _.assign(
            {},
            CorporateLandingHomePageLibrary.createQueryObject(
                i18n('ANALYTICS_PARAMETERS__HOME_PAGE__AIR_BOOKING_FLIFO')
            ),
            {
                departureDate: formData.LandingFlightStatusSearchForm_travelDate,
                destinationAirportCode: formData.LandingFlightStatusSearchForm_destinationAirportCode,
                flightNumber: formData.LandingFlightStatusSearchForm_flightNumber || '',
                originationAirportCode: formData.LandingFlightStatusSearchForm_originationAirportCode
            }
        );
    },

    getAirReservationQueryParams(formData, formType) {
        const formTypeKey = formType.split('_').pop();
        const formTypeParam = formData[`LandingAirReservationSearchForm_formType_${formTypeKey}`];
        const queryParams = {
            confirmationNumber: formData[`LandingAirReservationSearchForm_confirmationNumber_${formTypeKey}`],
            passengerFirstName: formData[`LandingAirReservationSearchForm_passengerFirstName_${formTypeKey}`],
            passengerLastName: formData[`LandingAirReservationSearchForm_passengerLastName_${formTypeKey}`]
        };

        queryParams.formType = formTypeParam;

        return _.assign(
            queryParams,
            CorporateLandingHomePageLibrary.createQueryObject(
                i18n(`ANALYTICS_PARAMETERS__HOME_PAGE__AIR_BOOKING_${formTypeParam}`)
            )
        );
    },

    getAppSettings() {
        this.appSettings = appSettings.getAppProps();
    },

    preventBrowserCache() {
        const browserInfo = browser.getBrowserInfo();

        // Does nothing but break the cache of firefox and safari
        // On FF, if you use back from select flights page, the page remains in a disabled state
        // because Firefox always uses the cache on the back button

        browserWindow.addEventListener('unload', _.noop);

        // Back-Forward cache listeners to prevent infinite loading in safari
        if (browserInfo && browserInfo.browserName === 'safari') {
            browser.addEventListener('pageshow', this.resetLoadingState);
            browser.addEventListener('popstate', this.resetLoadingState);
        }
    },

    // This is for reset all loading states in forms
    resetLoadingState() {
        this.setState({
            corporateLandingHomePageAirReservationSearchFormSearching: false,
            corporateLandingHomePageAirBookingSearchFormSearching: false,
            corporateLandingHomePageCheckInAirReservationFormSearching: false,
            corporatelandingHomePageFlightStatusSearchFormSearching: false
        });
    },

    areFormsEnabled() {
        return !this.state.formsDisabled;
    },

    getBackgroundAnimationSettings() {
        return _.get(this.appSettings, 'animation.background');
    },

    getPlacements(placementIds) {
        return this.state.fitState ? this.getFitStatePlacements(placementIds) : placementIds;
    },

    getFitStatePlacements(placementIds) {
        const fitStatePlacements = [];

        placementIds.map((placement) => {
            fitStatePlacements.push(`${placement}fit`);
        });

        return fitStatePlacements;
    },

    getFitState() {
        return browser.getGlobalScopeValue('swa.status', false);
    },

    getAnimationSettings(sectionName) {
        const appSettingsProps = appSettings.getAppProps();
        const animationEnabled = _.get(appSettingsProps, `animation.${sectionName}.enabled`, false);

        return animationEnabled ? _.get(appSettingsProps, `animation.${sectionName}`) : undefined;
    },

    getCarFormProps() {
        const { state } = this;
        const searchFormData = state.corporateLandingHomePageCarBookingSearchFormData;

        return {
            className: 'page-index--tab-navigation-form-container',
            formData: searchFormData ? searchFormData : undefined,
            interstitial: false,
            onFormUpdated: this.handleCarFormUpdated,
            onValidFormSubmitted: this.handleCorporateLandingPageCarBookingForm,
            queryParams: this.getCarBookingAnalyticsParams(),
            searching: state.corporateLandingHomePageCarBookingSearchFormSearching
        };
    },

    getWidthByState() {
        return this.isLoggedIn() ? 'full' : 'small';
    },

    getComponentForPanel(object, key) {
        const componentForPanel = _.clone(object);
        const ComponentPanel = object.panel;
        let getFormProps;

        if (enableCarTrawler && key === 'car') {
            getFormProps = this.getCarSectionProps;
        } else {
            getFormProps = this[`get${_.capitalize(key)}FormProps`];
        }

        let tabPanelContentProps = {};

        if (_.isFunction(getFormProps)) {
            tabPanelContentProps = getFormProps();
        }

        componentForPanel.panelInstance = <ComponentPanel {...tabPanelContentProps} />;
        componentForPanel.title = i18n(object.title);

        return componentForPanel;
    },

    getCarSectionProps() {
        return {
            loadScript: false,
            site: 'corporate'
        };
    },

    getCarBookingQueryParams(formData) {
        return _.assign(
            {},
            CorporateLandingHomePageLibrary.createQueryObject(
                i18n('ANALYTICS_PARAMETERS__HOME_PAGE__CAR_BOOKING_SEARCH')
            ),
            {
                carType: formData.LandingCarBookingSearchForm_carType,
                pickUpDate: formData.LandingCarBookingSearchForm_pickUpDate,
                pickUpLocation: formData.LandingCarBookingSearchForm_pickUpLocation,
                pickUpTime: formData.LandingCarBookingSearchForm_pickUpTime,
                reset: true,
                returnDate: formData.LandingCarBookingSearchForm_returnDate,
                returnLocation: formData.LandingCarBookingSearchForm_returnLocation,
                returnTime: formData.LandingCarBookingSearchForm_returnTime,
                vendors: formData.LandingCarBookingSearchForm_vendors
            }
        );
    },

    getCarBookingAnalyticsParams() {
        return CorporateLandingHomePageLibrary.createQueryObject(
            i18n('ANALYTICS_PARAMETERS__HOME_PAGE__CAR_BOOKING_ADVANCED_SEARCH')
        );
    },

    getSelectedTab() {
        return this.state.selectedTab;
    },

    getSelectedTabIndexByKey(tabKey) {
        const index = _.findIndex(Object.keys(this.tabNavigationData), (key) => tabKey === key);

        return index === -1 ? 0 : index;
    },

    getSelectedTabKeyByIndex(index) {
        return Object.keys(this.tabNavigationData)[index];
    },

    getDefaultTab(isLoggedIn) {
        return isLoggedIn ? 'flight' : this.isCiamLoginEnabled() ? 'checkIn' : 'login';
    },

    isCiamLoginEnabled() {
        const { ciamLoginEnabled = false } = appSettings.getAppProps();

        return ciamLoginEnabled;
    },

    setChangeCancelFormData(formData) {
        const updatedChangeCancelFormData = {};

        _.forEach(formData, (data, key) => {
            updatedChangeCancelFormData[`${key.split('_').slice(0, 2).join('_')}_change-cancel`] = data;
        });

        this.handleChangeCancelFormUpdated(updatedChangeCancelFormData);
    },

    setChangeCancelAsDefaultTab() {
        if (this.isLoggedIn()) {
            this.setState({
                selectedTab: 'changeCancel'
            });
        }
    },

    announceTitle() {
        ariaLiveActions.say(browser.getBrowserDocument().title);
    },

    isDashboardEnabled() {
        return (
            this.isLoggedIn() &&
            customerStore.getAccessLevel() === 'FULL' &&
            (corporateStore.isUnusedFundsIndEnabled() || corporateStore.getRewardsSummary())
        );
    },

    isCompanyEnrolledRapidRewards() {
        return !_.isEmpty(corporateStore.getRewardsSummary());
    },

    isMetaDataToggleOn(toggleName) {
        return this.getMetadataValue(toggleName, false);
    },

    upcomingTripsStoreUpdated() {
        landingHomePageIndexAnalytics();

        if (this.shoudCallUBBannerMbox()) {
            this.fireUpcomingTripsMbox();
        }
    },

    fireUpcomingTripsMbox () {
        mboxActions.updateMbox(null, this.mboxCallback, pageId, ["landingHomePageUpcomingTripsBannerSecondaryAction"]);
        upcomingTripsBannerFired = true;
    },

    mboxCallback: (additionalDataFromMbox) => {
        const currentTargetSegment = mboxStore.getMbox()?.target?.segment ?? [];
        const targetObject = {
            ...additionalDataFromMbox,
            segment: [
                ...currentTargetSegment,
                ...additionalDataFromMbox?.segment || []
            ]
        };

        return contentActions.updateContentFromServerUsingMbox(null, pageId, targetObject);
    },

    shoudCallUBBannerMbox() {
        const { upcomingTripsBanner, UBBannerMboxEnabled } = appSettings.getAppProps();
        const upcomingTrips = upcomingTripsStore.getSearchResults()?.upcomingTrips?.length;

        return (
            upcomingTripsBanner &&
            UBBannerMboxEnabled &&
            upcomingTrips &&
            !upcomingTripsBannerFired &&
            !mboxStore.isRequesting()
        );
    }
});

module.exports = StatePersistenceHOC(CorporateLandingHomePageIndex);
